// Subscription prices per currency key. The restaurant API returns currency as
// an integer. Resolve that integer through the dictionaries `currencies` list
// ({ value, key, label }) fetched from GET /dictionaries.

const BASE_LIST_PRICE_MARKUP = 0.3;

const SUBSCRIPTION_OFFERS = {
  EUR: {
    symbol: '€',
    base: { net: 100, gross: 119 },
    standard: { net: 150, gross: 178.5 },
  },
  PLN: {
    symbol: 'PLN',
    base: { net: 400, gross: 492 },
    standard: { net: 600, gross: 738 },
  },
};

export const resolveSubscriptionCurrency = (currency, currencies = []) => {
  if (currency == null || currency === '') return 'EUR';

  if (typeof currency === 'string') {
    const key = currency.trim().toUpperCase();
    if (SUBSCRIPTION_OFFERS[key]) return key;
  }

  const numeric = Number(currency);
  const match = currencies.find((item) => item?.value === numeric);
  if (match?.key && SUBSCRIPTION_OFFERS[match.key]) return match.key;

  return 'EUR';
};

export const getSubscriptionPlans = (currency, currencies = []) => {
  const key = resolveSubscriptionCurrency(currency, currencies);
  const offer = SUBSCRIPTION_OFFERS[key];
  const baseListPrice = Math.round(offer.base.net * (1 + BASE_LIST_PRICE_MARKUP));
  const savingsAmount = baseListPrice - offer.base.net;

  return {
    currency: key,
    symbol: offer.symbol,
    base: offer.base,
    standard: offer.standard,
    baseListPrice,
    savingsAmount,
    savingsPercent: Math.round((savingsAmount / offer.base.net) * 100),
  };
};

export const formatSubscriptionNet = (plan, symbol) => `${symbol}${plan.net}`;

export const formatSubscriptionGross = (plan, symbol) => `${symbol}${plan.gross.toFixed(2)}`;
